<div class="page-body">
  <div *ngIf="!loading" class="banner">
    <button type="button" class="back-button" (click)="handleCtaClick()">
      <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
      <span>Tillbaka</span>
    </button>
  </div>

  <div *ngIf="!loading && error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">Oops! Någonting gick fel.</p>
      <p class="info-text">
        Vänligen prova att ladda om sidan eller försök igen lite senare.
      </p>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner></app-spinner>
  </div>

  <div
    *ngIf="iframeUrl && !error"
    class="kreditz-iframe-container"
  >
    <app-kreditz-iframe
      [iframeUrl]="iframeUrl"
      (onEventData)="onEventData($event)"
    ></app-kreditz-iframe>
  </div>
</div>
